import {
  SetOracle as engagementDiscountManagerSetOracle,
  SetTier as engagementDiscountManagerSetTier,
  ClearTiers as engagementDiscountManagerClearTiers,
  SetTiers as engagementDiscountManagerSetTiers,
  RemoveTier as engagementDiscountManagerRemoveTier,
  ChangeOwner as engagementDiscountManagerChangeOwner,
  AdminMethods as EngagementDiscountManagerAdminMethods
 } from './admin';
import {
  GetAllTiersInfo as engagementDiscountManagerGetAllTiersInfo,
  GetUserDiscount as engagementDiscountManagerGetUserDiscount,
  GetContractOracle as engagementDiscountManagerGetContractOracle,
  GetContractDecimals as engagementDiscountManagerGetContractDecimals,
  GetUserTier as engagementDiscountManagerGetUserTier,
  GetUserLevel as engagementDiscountManagerGetUserLevel,
  GetTierInfo as engagementDiscountManagerGetTierInfo,
  ApplyUserDiscount as engagementDiscountManagerApplyUserDiscount,
  GetterMethods as EngagementDiscountManagerUserMethods
} from './getters';

const NamedAdminMethods = {
  engagementDiscountManagerSetOracle,
  engagementDiscountManagerSetTier,
  engagementDiscountManagerClearTiers,
  engagementDiscountManagerSetTiers,
  engagementDiscountManagerRemoveTier,
  engagementDiscountManagerChangeOwner,
};
const NamedUserMethods = {
  engagementDiscountManagerGetAllTiersInfo,
  engagementDiscountManagerGetUserDiscount,
  engagementDiscountManagerGetContractOracle,
  engagementDiscountManagerGetContractDecimals,
  engagementDiscountManagerGetUserTier,
  engagementDiscountManagerGetTierInfo,
  engagementDiscountManagerApplyUserDiscount,
  engagementDiscountManagerGetUserLevel,
};

export const EngagementDiscountManagerMethods = {
  ...NamedAdminMethods,
  ...NamedUserMethods,
}
export {
  EngagementDiscountManagerAdminMethods,
  EngagementDiscountManagerUserMethods
};
  
export default EngagementDiscountManagerMethods;